import type {
  ThirdPartyFeatureSettings,
  ThirdPartyFeatureSettingsUpdateRequest,
} from "@repo/shared/types";
import { get, patch } from "@/lib/api/_client";

const BASE = "/internal/tenant/third-party-features";

export function getThirdPartyFeatures(): Promise<ThirdPartyFeatureSettings> {
  return get<ThirdPartyFeatureSettings>(BASE);
}

export function updateThirdPartyFeatures(
  body: ThirdPartyFeatureSettingsUpdateRequest,
): Promise<ThirdPartyFeatureSettings> {
  return patch<ThirdPartyFeatureSettings>(
    BASE,
    body satisfies ThirdPartyFeatureSettingsUpdateRequest,
  );
}
